import React, { useEffect, useState } from "react";
import "./styles.css";
import { useLocation } from "react-router-dom";
import api from "../../Components/RefreshToken/RefreshToken";

const StudentsTable = () => {
    const TOKEN = localStorage.getItem("admin_token");
    const location = useLocation();
    const { courseTitle } = location.state || {};
    const [filteredResults, setFilteredResults] = useState([]);
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1); // Hozirgi sahifa
    const rowsPerPage = 10; // Har bir sahifada nechta element ko'rsatiladi



    const studentsWithResults = students.filter(student =>
        filteredResults.some(result => result.student_id === student.id)
    );

    const coursesWithResults = filteredResults.filter(student =>
        students.some(result => result.id === student.student_id)
    );

    // Sahifalash uchun hisob-kitob
    const totalPages = Math.ceil(studentsWithResults.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentStudents = studentsWithResults.slice(startIndex, startIndex + rowsPerPage);

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            window.scrollTo({ top: 0, behavior: 'smooth' }); // Sahifaning yuqorisiga scroll qilish
        }
    };

    return (
        <div className="table-container">
            <h2 className="">Students Course Schedule</h2>
            {loading ? (
                <div className="loaderWidth"><div className="loader"></div></div>
            ) : (
                <>
                    <table className="students-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Exam Chapters</th>
                                <th>Score</th>
                                {/* <th>Current Chapters</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {currentStudents.map((student, index) => (
                                <tr key={index}>
                                    <td>{startIndex + index + 1}</td>
                                    <td>{student?.first_name} {student?.last_name}</td>
                                    <td>
                                        {coursesWithResults
                                            ?.filter(course => course.student_id === student.id)
                                            ?.map((course, idx) => (
                                                <div key={idx}>{course.chapter_title}</div>
                                            ))}
                                    </td>
                                    <td>
                                        {coursesWithResults
                                            ?.filter(course => course.student_id === student.id)
                                            ?.map((course, idx) => (
                                                <div key={idx}>{course.total_score}</div>
                                            ))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {totalPages > 1 && (
                        <div className="paginations">
                            <button
                                className="pagination-studentBtn"
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>
                            <span className="pagination-info">
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                className="pagination-studentBtn"
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default StudentsTable;